import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { getRouteProps } from "./utils";
export const useRoute = () => {
    const location = useLocation();
    return useMemo(() => getRouteProps(location.pathname), [location]);
};
